export declare class PopupType {
  popup: HTMLElement | null
  triger: HTMLElement | null
  close: NodeListOf<HTMLElement> | null
  overlay: HTMLElement | null
  isOpen: boolean
  constructor(popup: string, triger: string, close: string)
  recunstruct: (popup: string | null, triger: string | null, close: string | null) => void
  init: () => void
  reset: () => void
  overlayClose: () => void
  openPopup: () => void
  onTriggerClick: () => void
  setOverlay: () => void
  setClose: () => void
  closeAll: () => void
}

export class Popup implements PopupType{
  popup: HTMLElement | null = null
  triger: HTMLElement | null = null
  close: NodeListOf<HTMLElement> | null = null
  overlay: HTMLElement | null = document.getElementById("overlay")
  isOpen:boolean = false

  constructor(popup: string, triger: string, close: string) {      
    this.popup = document.querySelector(popup) as HTMLElement | null
    this.triger = document.querySelector(triger) as HTMLElement | null
    this.close = document.querySelectorAll(close) as NodeListOf<HTMLElement>    
  }

  recunstruct(popup: string | null, triger: string | null, close: string | null) {
   this.reset()
    if (popup) {
      this.popup = document.querySelector(popup) as HTMLElement | null
      this.popup?.classList.add("init")
    }
    if (triger) {
      this.triger = document.querySelector(triger) as HTMLElement | null
    }
    if (close) {
      this.close = document.querySelectorAll(close) as NodeListOf<HTMLElement>
    }
  }

  init() {
    this.popup?.classList.add("init")
    this.openPopup()
    this.overlayClose()
    this.setClose()
    this.resetSlider()   
    this.windowClose()
 
  }

  reset() {
    if (this.popup && this.triger) {
      this.popup.dataset.open = "false"
      this.triger.dataset.open = "false"
      this.triger.classList.remove("activeClass", "jsPopupOpen")
      this.popup.classList.remove("activeClass", "jsPopupOpen")
    }
  }





  overlayClose() {
    this.overlay?.addEventListener("click", () => {
      this.isOpen = false
      this.setOverlay()
    })


  }

  windowClose() {
    window.addEventListener('click', (e) => {

      const target = e.target as HTMLElement; 
      const user = document.getElementById('jsOpenUser') as HTMLElement; 
      const userWrap = document.getElementById('jsUserWrap') as HTMLElement; 
      const cart = document.getElementById('jsOpenCart') as HTMLElement; 
      const cartWrap = document.getElementById('jsCartWrap') as HTMLElement; 
      const search = document.getElementById('jsOpenSearch') as HTMLElement; 
      const searchWrap = document.getElementById('jsSearchWrap') as HTMLElement; 
      const menu = document.getElementById('jsOpenMenu') as HTMLElement; 
      const menuWrap = document.getElementById('jsMenuWrap') as HTMLElement; 
      const filter = document.getElementById('jsOpenFilter') as HTMLElement | null; 
      const filterWrap = document.getElementById('jsFilterWrap') as HTMLElement | null; 
      const stock = document.getElementById('jsOpenLocation') as HTMLElement | null; 
      const stockWrap = document.getElementById('jsLocationWrap') as HTMLElement | null; 
      const shipping = document.getElementById('jsOpenShipping') as HTMLElement | null; 
      const shippingWrap = document.getElementById('jsShippingWrap') as HTMLElement | null; 
      const enquire = document.getElementById('jsOpenEnquire') as HTMLElement | null; 
      const enquireWrap = document.getElementById('jsEnquireWrap') as HTMLElement | null; 
      const gallery = document.getElementById('jsOpenGallery') as HTMLElement | null; 
      const galleryWrap = document.getElementById('jsGalleryWrap') as HTMLElement | null; 
      const price = document.getElementById('jsOpenPricing') as HTMLElement | null; 
      const priceWrap = document.getElementById('jsPriceWrap') as HTMLElement | null; 
      const freeShipping = document.getElementById('jsOpenfreeShipping') as HTMLElement | null;
      const freeShippingWrap = document.getElementById('jsFreeShippingWrap') as HTMLElement | null;
      const bulky = document.getElementById('jsBulkyOpen') as HTMLElement | null;
      const bulkyWrap = document.getElementById('jsBulkyWrap') as HTMLElement | null;

      if(target !== user && !user.contains(target) && target !== cart && !cart.contains(target) && target !== menu && !menu.contains(target) && target !== search && !search.contains(target) && target !== searchWrap && !searchWrap.contains(target) && target !== userWrap && !userWrap.contains(target) && target !== cartWrap && !cartWrap.contains(target) && target !== menuWrap && !menuWrap.contains(target) && target !== filter && !filter?.contains(target) && target !== filterWrap && !filterWrap?.contains(target) && target !== stock && !stock?.contains(target) && target !== stockWrap && !stockWrap?.contains(target) && target !== shipping && !shipping?.contains(target) && target !== shippingWrap && !shippingWrap?.contains(target) && enquire !==  target && !enquire?.contains(target) && enquireWrap !== target && !enquireWrap?.contains(target) && gallery !== target && !gallery?.contains(target) && galleryWrap !== target && !galleryWrap?.contains(target) && price !== target && !price?.contains(target) && priceWrap !== target && !priceWrap?.contains(target) && target !== freeShipping && !freeShipping?.contains(target) && freeShippingWrap !== target && !freeShippingWrap?.contains(target) && target !== bulky && !bulky?.contains(target) && target !== bulkyWrap && !bulkyWrap?.contains(target)     ) {
      this.closeAll()
      }
     })
  }



  openPopup() {
    if (this.popup && this.triger) {
      this.triger.addEventListener("click", this.onTriggerClick.bind(this))
    }
  }

  onTriggerClick() {
    if (this.popup && this.triger) {
      if (this.triger.dataset.open === "false") {
        this.isOpen = true
        this.setOverlay()   
        window.dispatchEvent(window.popupOpenEvent);   
      } else {
        this.isOpen = false     
        this.setOverlay() 
      }
    }
  }

  setOverlay() {
    if (this.popup && this.triger) {    
      if ( this.isOpen ) {
        this.closeAll()
        this.popup.classList.add("activeClass", "jsPopupOpen")
        this.popup.dataset.open = "true"
        this.triger.dataset.open = "true"
        this.triger.classList.add("activeClass", "jsPopupOpen")
        this.overlay?.classList.add("activeClass")
        document.documentElement.style.overflow = "hidden"
        document.body.classList.add("activeClass")
      } else {
        this.popup.classList.remove("activeClass", "jsPopupOpen")
        this.popup.dataset.open = "false"
        this.triger.dataset.open = "false"
        this.triger.classList.remove("activeClass", "jsPopupOpen")
        this.overlay?.classList.remove("activeClass")
        document.documentElement.style.overflow = "auto"
        document.body.classList.remove("activeClass")
      }
    }
  }
  setClose() {
    this.close?.forEach((item) => {
      item.addEventListener("click", () => {
        this.isOpen = false
        this.setOverlay()
      })
    })
  }
  resetSlider() {
    window.addEventListener("closePopups", () => {    
      this.closeAll()
    })
  }
  closeAll() {
    const popups = document.querySelectorAll(".jsPopupOpen") as NodeListOf<HTMLElement>
    this.overlay?.classList.remove("activeClass")
    document.documentElement.style.overflow = "auto"
    document.body.classList.remove("activeClass")   
    window.dispatchEvent(window.popupsClosedEvent);
    popups.forEach((item) => {
      item.classList.remove("activeClass", "jsPopupOpen")
      item.dataset.open = "false"
    })
  }
}
